export default {
  apiURL: null
}
